import type { PlotShape } from "../plot/PlotShape"
import type { Distance } from "../units/Units"
import type { Rectangle } from "./Rectangle"

export type Page = Readonly<
  {
    shapes: PlotShape[]
    bleed?: Distance
  } & Rectangle<Distance>
>
